<div class="flex flex-col gap-4">
  <app-match-tab-bar (valueTap)="handleHeaderTap($event)" />

  @switch (selectedMatchTab()) { @case (0) {
  <app-summary
    [competition]="competition()"
    [tsExternalMatchId]="tsExternalMatchId()"
    [gamePeriod]="gamePeriod()"
  />
  } @case (1) {
  <app-stats />
  } @case (2) {
  <app-lineup-new [tsExternalMatchId]="tsExternalMatchId()" />
  } @case (3) {
  <app-information />
  } @default {
  <div>por defecto</div>
  } }
</div>
